export default {
    state: {
        searchSelected: null,
        poiSelected: null,
        isSearchConfirmBack: null,
        position: null,
        listRefresh: false,
    },
    actions: {},
    mutations: {
        SPOTSURVEY_SEARCH_SELECTED: function (state, val) {
            state.searchSelected = val;
        },
        SPOTSURVEY_POI_SELECTED: function (state, val) {
            state.poiSelected = val;
        },
        SPOTSURVEY_SEARCH_POI_CONFIRMED: function (state, val) {
            state.isSearchConfirmBack = val;
        },
        SPOTSURVEY_POSITION: function (state, val) {
            state.position = val;
        },
        SPOTSURVEY_LIST_REFRESH: function (state, val) {
            state.listRefresh = val;
        },
    },
    getters: {}
};
